import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';

export interface GeneralDialogPropsOptions {
    text: string,
    action: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
    color?: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning',
    variant?: 'text' | 'outlined' | 'contained';
}

export interface GeneralDialogProps {
    open: boolean,
    title: string,
    message: string,
    options: GeneralDialogPropsOptions[]
}

export const GeneralDialog = (props: GeneralDialogProps) => {
    return (
        <div>
            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {props.options.map((item) => {
                        return (
                            <Button key={item.text} onClick={(event) => item.action(event)} color={item.color} variant={item.variant}>
                                {item.text}
                            </Button>
                        )
                    })}
                </DialogActions>
            </Dialog>
        </div>
    );
};